// src/config.js
export const WEB_APP_URL = 'https://script.google.com/macros/s/AKfycbxjLYyhcEwSMLaHB5Lc_cuP5aq_cuL_Ra8wRtyQ7G09fz5xFGX-ER77cfvEUlVhq-u6/exec';


export const SECRET_TOKEN = 'anastasiacute';
